/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import Typography from "../../../../components/common/new/Typography/Typography";
import { SET_SELECTED_MEMBER_PROFILE } from "../../../../redux/actionTypes/dashboard";
import { ROUTES } from "../../../../utils/constants";
import styles from "./styles";
import { AlertStatus, PERMISSIONS } from "../../../../contants";
import { getInitials } from "../utlis";
import ProfilePictureModal from "../../../../components/common/new/ProfilePictureModal/ProfilePictureModal";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import NewEdit from "../../../../assets/svg/NewEdit";
import Member from "../../../../services/api/member";
import Loader from "../../../../components/common/Loader/Loader";
import { getSubDivisionDisplayName } from "../../../../utils/helper";

function ProfileRow({ lebel, value, color, truncate = false }) {
  return (
    <Box style={styles.rowContainer} py="8px">
      <Box style={truncate ? styles.truncateRowKey : styles.rowKey}>
        <Typography weight={600} fontSize="14px" color={color || "#393939"}>
          {lebel}
        </Typography>
      </Box>
      <Box style={truncate ? styles.truncate : styles.rowValue}>
        <Typography fontSize="16px" color={color || "#393939"}>
          {value || "NA"}
        </Typography>
      </Box>
    </Box>
  );
}

export default function MemberDetailBoxs({
  memberInfo,
  hasPermission,
  onRefresh,
}) {
  const {
    memberId,
    fullName,
    mobileNumber,
    emailId,
    nationalityName,
    addressLine1,
    cityName,
    pincode,
    stateName,
    introducerName,
    introducerEmail,
    introducerMobileNumber,
    divisionName,
    subDivisionName,
    dateOfBirth,
    dateOfJoining,
    universityName,
    collegeName,
    professionName,
  } = memberInfo;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPhotoLoading, setIsPhotoLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const toast = useContext(ToastAlertContext);
  const { id } = useParams();
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen((prev) => !prev);
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleImageUpload = async () => {
    try {
      if (selectedImage) {
        const file = new File([selectedImage], "image.jpg", {
          type: "image/jpeg",
        });

        const formData = new FormData();

        formData.append("file", file);

        setIsPhotoLoading(true);
        await Member.uploadProfilePhoto({
          memberId: Number(id),
          data: formData,
        });
        toast.show("Image Uploaded Successfully", AlertStatus.SUCCESS);
        setTimeout(() => {
          onRefresh();
          setModalOpen(false);
        }, 2000);
      }
      setIsPhotoLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const onEditClick = () => {
    setIsPhotoLoading(true);
    setTimeout(() => {
      dispatch({ type: SET_SELECTED_MEMBER_PROFILE, payload: memberInfo });
      navigate(`${ROUTES.MEMBER_EDIT_PROFILE.path}/${memberId}`);
      setIsPhotoLoading(false);
    }, 2000);
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 10000);
  // }, []);

  return (
    <Box style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <Box
        style={{
          ...styles.cardContainerMobile,
          background:
            "linear-gradient(180deg, #B6E5FF 0%, rgba(255, 255, 255, 0.21) 100%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box sx={styles.imgContainer}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {memberInfo.profilePhotoUrl ? (
                <img
                  src={memberInfo.profilePhotoUrl}
                  alt=""
                  style={styles.profileImage}
                  width="120"
                  height="120"
                />
              ) : (
                <div style={styles.imageView} width="150" height="150">
                  {getInitials(memberInfo.fullName)}
                </div>
              )}
              {hasPermission(PERMISSIONS.UPDATE_MEMBER_PROFILE_PHOTO) && (
                <Box
                  style={{
                    cursor: "pointer",
                    position: "relative",
                    top: 20,
                    right: 10,
                  }}
                >
                  <NewEdit onClick={handleModalOpen} color="white" isPhoto />
                </Box>
              )}
            </div>
          </Box>
          <Box textAlign="center" mt={3}>
            <Typography
              weight={600}
              variant="body"
              fontSize="22px"
              color="#0E78B6"
            >
              {fullName}
            </Typography>
          </Box>
          <ProfileRow
            color="#143786"
            lebel="Date of Joining"
            value={
              dateOfJoining ? moment(dateOfJoining).format("DD-MM-YYYY") : "NA"
            }
          />
          <ProfileRow
            color="#143786"
            lebel="Date of Birth"
            value={dateOfBirth ? moment(dateOfBirth).format("MM-YYYY") : "NA"}
          />
          <ProfileRow color="#143786" lebel="Phone No" value={mobileNumber} />
          <ProfileRow color="#143786" lebel="Email" truncate value={emailId} />
          <ProfileRow
            color="#143786"
            lebel="Nationality/Country"
            value={nationalityName}
          />
        </Box>
      </Box>

      <Box
        style={{
          ...styles.cardContainerMobile,
          background:
            "linear-gradient(180deg, rgba(236, 192, 252, 0.28) 0%, rgba(255, 255, 255, 0.51) 68.23%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography style={styles.cardHeading}>Address Details</Typography>
            {hasPermission(PERMISSIONS.UPDATE_MEMBER) ||
            hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) ||
            hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME) ? (
              <Box style={{ cursor: "pointer" }}>
                <NewEdit onClick={onEditClick} />
              </Box>
            ) : null}
          </Box>

          <ProfileRow
            color="#393939"
            lebel="Address"
            truncate
            value={addressLine1}
          />
          <ProfileRow lebel="State" value={stateName} />
          <ProfileRow lebel="City" value={cityName} />
          <ProfileRow lebel="Pincode" value={pincode} />

          <div style={{ paddingTop: "20px" }} />

          <Typography style={styles.cardHeading}>
            Professional Details
          </Typography>
          <ProfileRow lebel="University" value={universityName} />
          <ProfileRow lebel="College" value={collegeName} />

          <ProfileRow lebel="Profession" value={professionName} />
        </Box>
      </Box>

      <Box
        style={{
          ...styles.cardContainerMobile,
          background:
            "linear-gradient(180deg, rgba(255, 239, 194, 0.28) 0%, rgba(255, 255, 255, 0.51) 68.23%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography style={styles.cardHeading}>Additional Info</Typography>
            {hasPermission(PERMISSIONS.UPDATE_MEMBER) ||
            hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) ||
            hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME) ? (
              <Box style={{ cursor: "pointer" }}>
                <NewEdit onClick={onEditClick} />
              </Box>
            ) : null}
          </Box>

          <ProfileRow lebel="Introducer's Name" value={introducerName} />
          <ProfileRow
            lebel="Introducer's Number"
            value={introducerMobileNumber}
          />
          <ProfileRow lebel="Introducer's Email" value={introducerEmail} />

          <div style={{ paddingTop: "20px" }} />

          <Typography style={styles.cardHeading}>Division Details</Typography>
          <ProfileRow lebel="Division" value={divisionName} />
          <ProfileRow
            lebel="Sub Division"
            value={getSubDivisionDisplayName(subDivisionName)}
          />
        </Box>
      </Box>
      <ProfilePictureModal
        open={modalOpen}
        onClose={handleModalClose}
        handleImageChange={handleImageChange}
        handleImageUpload={handleImageUpload}
        memberProfile={memberInfo}
        isPhotoLoading={isPhotoLoading}
        toast={toast}
      />
      {isPhotoLoading && <Loader />}
    </Box>
  );
}
